<div class="flex bg-white rounded-xl  py-4 gap-4 h-[114px] relative mx-4 cursor-pointer hover:shadow-lg transition-shadow" (click)="goToBenefistInfo()">
  
  <div class="flex items-center">
    <div class="circle-right"></div>
    <img [src]="logo" alt="Logo" class="w-12 h-12 object-contain m-1" />
  </div>
  <div class="dotted-line">
  </div>
  <div class="flex flex-col justify-between flex-1 min-h-0 min-w-0">
    <div class="flex-1 min-h-0 min-w-0">
      <h3 class="headline-05 line-clamp-2 overflow-hidden break-words">{{ descripcion }}</h3>
      <p class="headline-03 text-[#134F82] truncate">{{ nombreMarca }}</p>
    </div>
    <p class="paragraph-small pt-1 flex-shrink-0 truncate">Válido hasta el {{ fechaValidez }}</p>
  </div>
  <div class="flex items-center">
    <div class="circle-left"></div>
  </div>
  
</div>